import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=4e633bf2&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=4e633bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e633bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e633bf2')) {
      api.createRecord('4e633bf2', component.options)
    } else {
      api.reload('4e633bf2', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=4e633bf2&scoped=true&", function () {
      api.rerender('4e633bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Tabs.vue"
export default component.exports